import React from 'react';
import { Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

interface MoveDeviceSummaryProps {
  onClose: () => void;
  success: Array<string>;
  errors: Array<string>;
  title?: string;
  successLabel?: string;
  errorLabel?: string;
  buttonColor?: string;
}

const MoveDeviceSummary: React.FC<MoveDeviceSummaryProps> = ({
  onClose,
  success,
  errors,
  title = 'Summary',
  successLabel = 'Devices were successfully moved:',
  errorLabel = 'Devices that have not been moved:',
  buttonColor = 'primary',
}) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <ModalHeader toggle={handleClose}>{title}</ModalHeader>
      <ModalBody>
        {success?.length > 0 && (
          <>
            <b>{successLabel}</b>
            <ul style={{ paddingLeft: '15px' }}>
              {success?.map(item => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </>
        )}
        {errors?.length > 0 && (
          <>
            <b>{errorLabel}</b>
            <ul style={{ paddingLeft: '15px' }}>
              {errors?.map(item => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color={buttonColor as any} onClick={handleClose}>
          Close
        </Button>
      </ModalFooter>
    </>
  );
};

export default React.memo(MoveDeviceSummary);
